import { useEffect, useState } from "react";
import { Accessibility } from "lucide-react";
import AuthWindow from "../components/AuthWindow";
import SiteLayout from "../components/SiteLayout";
import { ForceLogo } from "../components/ForceLogo";
import { api } from "../lib/api";
import { useSiteConfig } from "../context/SiteConfigContext";

export default function Landing() {
    const [jobsToday, setJobsToday] = useState(null);
    const { easyMode, setEasyMode, siteLayout } = useSiteConfig();

    useEffect(() => {
        let alive = true;
        api.get("/stats/public")
            .then((r) => { if (alive) setJobsToday(r.data?.jobs_today ?? null); })
            .catch(() => {});
        return () => { alive = false; };
    }, []);

    const header = (
        <header className="relative z-20 flex items-center justify-between px-6 sm:px-10 py-6">
            <ForceLogo size={38} />
            <div className="flex items-center gap-3">
                {siteLayout !== "easy" && !easyMode && (
                    <button
                        data-testid="easy-mode-toggle"
                        onClick={() => setEasyMode(true)}
                        className="flex items-center gap-2 rounded-full border-2 border-orange-500/60 bg-orange-500/15 px-4 py-2 text-sm font-extrabold text-orange-300 transition-colors hover:bg-orange-500/25"
                    >
                        <Accessibility className="h-4 w-4" /> Easy Mode
                    </button>
                )}
                <div className="hidden sm:flex items-center gap-2 text-xs font-mono text-orange-300/90" data-testid="live-jobs-stat">
                    <span className="h-2 w-2 rounded-full bg-orange-400 animate-pulse-glow" />
                    LIVE · {jobsToday ?? "…"} jobs posted near you today
                </div>
            </div>
        </header>
    );

    return <SiteLayout header={header} rightSlot={<AuthWindow />} />;
}
